import { ObservableFromFetch } from "../ObservableFromFetch"
import { ImplementationGroupID_Workforce } from "../../config/Constants"
import ImplementationLabResultsReporting from "./Model/ImplementationLabResultsReporting"



export default function ImplementationLabResultsReportingGet() {
  const requestBody: string = new URLSearchParams({
    implementationGroupId: ImplementationGroupID_Workforce.toString()
  }).toString()
  return ObservableFromFetch<ImplementationLabResultsReporting[]>("WorkforceLabResultsReporting/GetImplementations?" + requestBody)
}

export  function ImplementationLabResultReportingGet(implementationId: number) {
  const requestBody: string = new URLSearchParams({
    implementationId: implementationId.toString()
  }).toString()
  return ObservableFromFetch<ImplementationLabResultsReporting>("WorkforceLabResultsReporting/GetImplementation?" + requestBody)
}

export  function SetImplementationLabResultsReporting(data: ImplementationLabResultsReporting) {
  const requestBody: string = JSON.stringify(data)

  return ObservableFromFetch<string>("WorkforceLabResultsReporting/SetImplementationLabResultsReporting", requestBody)
}